/* eslint-disable no-console */

const store = {
  isReady: false,
  dispatch: () => {
    console.log('store is not ready');
  },
};

export default store;
